<section #aboutContainer class="story-tab" [ngClass]="{'desktop-story-tab': isMobile}">
  <app-inner-templater *ngIf="storyDescription?.info_1" class="story-description" [innerHtml]="storyDescription?.info_1"></app-inner-templater>
  <div *ngIf="!isShown && isMobile" #showMore class="show-more show-more-effect">
    <button  class="show-btn" mat-raised-button (click)="toggleClass()">
      Read Full Story
    </button>
  </div>
</section>
